import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Container, Grid, Button, IconButton, Typography, Box } from '@material-ui/core';
import { postDigitalRecord, putDigitalRecord, printRecord, deleteDigitalRecord } from '../../store/actions/appointments/appointments_action';
import { connect, useDispatch } from 'react-redux';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { API_PREFIX as API, API_ROUTES } from '../../constants/api_routes';
import Autocomplete from '../ui_components/autocomplete_controlled';
import { ErrorMessage } from '@hookform/error-message';
import PrintComponent from '../ui_components/print_component';
import FormDigitalRecordTherapy from './digital_record_therapy';
import { Delete } from '@material-ui/icons';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { getData } from "../../http/request";
import { ENTRYPOINT } from "../../config/entrypoint";
import { mapAppointmentData } from "../../store/reducers/appointments/appointments_reducer";
import { AddBox } from '@material-ui/icons';
import FormShortcut from '../ui_components/form_shortcut';
import SubAreaComponent from '../sub_area/sub_area';
import { RecentActors } from '@material-ui/icons';
import DigitalRecordModal from '../customer/digital_record_modal';
import Textarea from "../ui_components/textarea";

const useStyles = makeStyles((theme) => ({
    container: {
        width: 'auto',
        padding: theme.spacing(2, 5),
        '& b': {
            color: '#bf1650',
            '&::before': {
                display: 'inline',
                content: '"⚠ "'
            }
        }
    },
    saveButtonGrid: {
        textAlign: 'right'
    },
    alignCenter: {
        textAlign: 'center'
    },
    iconButton: {
        padding: theme.spacing(0),
        marginTop: theme.spacing(3)
    },
    inlineFlex: {
        display: 'inline-flex'
    },
    iconButtonLabel: {
        display: 'flex',
        flexDirection: 'column'
    },
    textEditor: {
        "& .ck-editor__main > .ck-editor__editable": {
            minHeight: "150px"
        }
    },
    accentField: {
        border: "solid 1px #EDEDED",
        padding: "0px 10px 10px",
        borderRadius: "12px",
        "& textarea": {
            resize: "vertical"
        }
    }
}));

const DigitalRecord = (props) => {
    let { appointmentData, setOpen } = props;
    const { container, alignCenter, iconButton, inlineFlex, iconButtonLabel, textEditor, accentField } = useStyles();
    const { handleSubmit, setValue, control, reset, formState: { errors } } = useFormContext();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'digitalRecordTherapy'
    })

    const [area, setArea] = useState(null);
    const [subArea, setSubArea] = useState(null);

    const [openDialog, setOpenDialog] = React.useState(false);
    const [saving, setSaving] = React.useState(false);
    const [appointment, setAppointment] = React.useState(appointmentData);
    const [digitalRecordOpen, setDigitalRecordOpen] = useState(false);

    const handleClickDigitalRecord = () => {
        setDigitalRecordOpen(true);
    }
    const handleClickOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    // SubArea Component shortcut
    const [openSubAreaComponent, setOpenSubAreaComponent] = useState(false);
    const handleClickOpenSubAreaComponent = () => {
        setOpenSubAreaComponent(true);
    };
    const handleCloseSubAreaComponent = () => {
        setOpenSubAreaComponent(false);
    };

    const initializeSubArea = (subArea) => {
        if (subArea) {
            enqueueSnackbar('Uspešno ste sačuvali dijagnozu', { variant: 'success' });
            setSubArea(subArea);
            setValue('subArea', subArea);
        }
    };

    const updateAppointment = (appointmentObject) => {
        if (appointmentObject?.worker?.initialTextForReport) {
            setValue('description', appointmentObject.worker.initialTextForReport);
        }
        if (appointmentObject?.digitalRecord?.description) {
            setValue('description', appointmentObject.digitalRecord.description);
        }
        if (appointmentObject?.digitalRecord?.diagnosis) {
            setValue('diagnosis', appointmentObject.digitalRecord.diagnosis);
        }
        if (appointmentObject?.digitalRecord?.area) {
            setArea(appointmentObject?.digitalRecord?.area);
            setValue('area', appointmentObject.digitalRecord.area);
        }
        else {
            setValue('area', '');
        }
        if (appointmentObject?.digitalRecord?.subAreas) {
            setSubArea(appointmentObject?.digitalRecord?.subAreas);
            setValue('subArea', appointmentObject.digitalRecord.subAreas);
        }
        else {
            setValue('subArea', []);
        }
        if (appointmentObject?.digitalRecord?.digitalRecordTherapy) {
            setValue('digitalRecordTherapy', appointmentObject?.digitalRecord?.digitalRecordTherapy);
        }
        else {
            setValue('digitalRecordTherapy', []);
            reset({'digitalRecordTherapy' : []});
        }
    }

    useEffect(() => {
        updateAppointment(appointmentData);
        setAppointment(appointmentData);
        return () => {
            reset();
            setArea(null);
            setSubArea(null);
            setSaving(false);
        }
    }, [appointmentData]);

    const handleAddDigitalRecord = async (data) => {
        setSaving(true);
        if (typeof data['digitalRecordTherapy'] !== 'undefined') {
            data['digitalRecordTherapy'].map((digitalRecordTherapy, index) => {
                data['digitalRecordTherapy'][index]['therapy'] = `${digitalRecordTherapy['therapy']}`;
                data['digitalRecordTherapy'][index]['wayOfUse'] = `${digitalRecordTherapy['wayOfUse']}`;
            });
        }
        data['uuid'] = appointment.digitalRecord?.uuid;
        data['appointment'] = `${API}${API_ROUTES.APPOINTMENTS}/${appointment.id}`;
        data['area'] = area && `${API}${API_ROUTES.AREAS}/${area?.uuid}`;
        delete data['subArea'];
        delete data['subAreas'];
        if (subArea) {
            data['subAreas'] = subArea.map((sArea) => {
                if (sArea['@id'] != undefined) {
                    return sArea['@id'];
                }
                else {
                    return sArea;
                }
            })
        }
        if (data['uuid']) {
            const { detail } = await dispatch(putDigitalRecord(data));
            detail ? enqueueSnackbar(detail, { variant: 'warning' }) : enqueueSnackbar('Uspešno izmenjen izveštaj', { variant: 'success' });
            setSaving(false);
            return setOpen(true);
        }
        else {
            const { detail } = await dispatch(postDigitalRecord(data));
            detail ? enqueueSnackbar(detail, { variant: 'warning' }) : enqueueSnackbar('Uspešno dodat izveštaj', { variant: 'success' });
            setOpen(true);
        }

        setTimeout(() => {
            getData(`${ENTRYPOINT}${API_ROUTES.APPOINTMENTS}/${appointment.id}`)
                .then((data) => {
                    const object = mapAppointmentData(data);
                    updateAppointment(object);
                    setAppointment(object);
                    setSaving(false);
                })
        }, 1000);
    };

    // const handleAreaObject = (object) => {
    //     setArea(object);
    //     setValue('area', object);
    // }

    const handleSubAreaObject = (object) => {
        setSubArea(object);
        setValue('subArea', object);
    }

    const getPrintContent = () => printRecord(appointment.digitalRecord?.uuid);

    const deleteDigitalReportClick = async () => {
        deleteDigitalRecord(dispatch, appointment.digitalRecord?.uuid, appointment.id)
            .then(() => {
                enqueueSnackbar('Uspešno obrisan izveštaj', { variant: 'success' });
                updateAppointment(null);
                setAppointment(null);
            });
        setOpen(false);
        setTimeout(() => {
            getData(`${ENTRYPOINT}${API_ROUTES.APPOINTMENTS}/${appointment.id}`)
                .then((data) => {
                    const object = mapAppointmentData(data);
                    updateAppointment(object);
                    setAppointment(object);
                })
        }, 1000);
    }

    return (
        <Container className={container}>
            <form>
                <Grid container justify="center" spacing={3}>
                    <Grid container justify="space-around" alignItems='center' spacing={3}>
                        <Grid item xs={6}>
                            <Button
                                disabled={saving}
                                onClick={handleSubmit(handleAddDigitalRecord)}
                                variant="contained"
                                size="small"
                                color="primary"
                                type="submit"
                            >
                                Sačuvaj
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Box align="right">
                                {appointmentData && appointmentData.customer &&
                                    <IconButton classes={{ label: iconButtonLabel }} onClick={() => handleClickDigitalRecord()}>
                                        <RecentActors fontSize="default" />
                                            <Typography variant="caption" gutterBottom>
                                                Digitalni karton
                                            </Typography>
                                    </IconButton>
                                }
                                {appointment && appointment.digitalRecord &&
                                    <IconButton
                                        type="button"
                                        variant="contained"
                                        size="small"
                                        onClick={handleClickOpenDialog}>
                                        <Delete />
                                    </IconButton>
                                }
                            </Box>
                        </Grid>
                        <Grid>
                            <Typography component="h2" variant="h4" align="center">
                                Izveštaj
                            </Typography>
                            {appointment && appointment.digitalRecord &&
                                <div className={alignCenter}>
                                    <PrintComponent getPrintContent={getPrintContent} />
                                </div>
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs={12} className={inlineFlex}>
                        <Autocomplete
                            name="subArea"
                            control={control}
                            label="Dijagnoza"
                            placeholder="Dijagnoza"
                            parameters={area ? `&area=${area?.uuid}` : ''}
                            handleObject={handleSubAreaObject}
                            api={API_ROUTES.SUB_AREAS}
                            preloadValue={subArea}
                            multiple
                        />
                        <IconButton className={iconButton} onClick={() => handleClickOpenSubAreaComponent()}>
                            <AddBox
                                color="primary"
                                fontSize="large"
                            />
                        </IconButton>
                        <ErrorMessage errors={subArea} name="subArea" as="b" />
                    </Grid>
                    <Grid item xs={12}>
                        <div className={[textEditor, accentField].join(" ")}>
                            <Textarea
                                data={appointment?.digitalRecord?.description ?? appointment?.worker?.initialTextForReport}
                                name="description"
                                rows={16}
                                label="Nalaz, mišljenje"
                                multiline
                                rules={{ required: 'Unesite nalaz, mišljenje' }}
                            />
                        </div>
                        <ErrorMessage errors={errors} name="description" as="b" />
                    </Grid>
                    <FormDigitalRecordTherapy
                        control={control}
                        fields={fields}
                        append={append}
                        remove={remove}
                        setValue={setValue}
                        errors={errors}
                    />
                    {/*<Grid item xs={12}>*/}
                    {/*    <Autocomplete*/}
                    {/*        name="area"*/}
                    {/*        control={control}*/}
                    {/*        label="Oblast"*/}
                    {/*        placeholder="Oblast"*/}
                    {/*        handleObject={handleAreaObject}*/}
                    {/*        api={API_ROUTES.AREAS}*/}
                    {/*        preloadValue={area}*/}
                    {/*    />*/}
                    {/*</Grid>*/}
                </Grid>
                <FormShortcut
                    component={SubAreaComponent}
                    open={openSubAreaComponent === 0 || openSubAreaComponent ? true : false}
                    handleClose={handleCloseSubAreaComponent}
                    initialize={initializeSubArea}
                />
                <DigitalRecordModal
                    customerUuid={appointmentData.customer && appointmentData.customer.uuid}
                    customerName={appointmentData.customer && `${appointmentData.customer.firstName} ${appointmentData.customer.lastName}`}
                    customerBirthYear={appointmentData.customer && appointmentData.customer.customerBirthYear}
                    open={digitalRecordOpen}
                    setOpen={setDigitalRecordOpen}
                />
            </form>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <DialogContentText>
                        Da li ste sigurni da želite da obrišete izveštaj?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleCloseDialog} color="primary">
                        Ne
                    </Button>
                    <Button onClick={deleteDigitalReportClick} color="primary" autoFocus>
                        Da
                    </Button>
                </DialogActions>
            </Dialog>
        </Container>
    );
};

DigitalRecord.propTypes = {
    appointmentData: PropTypes.object,
    appointments: PropTypes.array,
    setOpen: PropTypes.func,
    onHide: PropTypes.func
}

const mapStateToProps = (state) => ({
    appointments: state.appointments
})

DigitalRecord.defaultValues = {
    appointments: []
}

export default connect(mapStateToProps)(DigitalRecord);
